function path(root, sublink) {
  return `${root}${sublink}`;
}

const ROOTS_AUTH = "";
const ROOTS_DASHBOARD = "/dashboard";
const ROOTS_COMMERCE = "/commerce";

// ----------------------------------------------------------------------

export const PATH_AUTH = {
  root: ROOTS_AUTH,
  signIn: path(ROOTS_AUTH, "/signin"),
  signUp: path(ROOTS_AUTH, "/signup"),
  resetPassword: path(ROOTS_AUTH, "/reset-password"),
  newPassword: path(ROOTS_AUTH, "/new-password"),
};

export const PATH_DASHBOARD = {
  root: path(ROOTS_DASHBOARD, "/home"),
  balances: path(ROOTS_DASHBOARD, "/balances"),
  payments: path(ROOTS_DASHBOARD, "/payments"),
  checkouts: path(ROOTS_DASHBOARD, "/checkouts"),
  invoices: path(ROOTS_DASHBOARD, "/invoices"),
  cryptoSetting: path(ROOTS_DASHBOARD, "/crypto-settings"),
  settings: path(ROOTS_DASHBOARD, "/settings"),
  blanks: path(ROOTS_DASHBOARD, "/blanks"),
  /* PLOP_COMPONENTS_ROUTE_IMPORT */
  OperationWalletManagement: path(ROOTS_DASHBOARD, "/operating-wallet/ow-management"),
  walletlog: path(ROOTS_DASHBOARD, "/operating-wallet-history-log"),
  operatingactions: path(ROOTS_DASHBOARD, "/operating-wallet-history-log/operatingactions"),
  tokentransactions: path(ROOTS_DASHBOARD, "/operating-wallet-history-log/tokentransactions"),
  owHistoryLog: path(ROOTS_DASHBOARD, "/operating-wallet-history-log/history-log"),
  Whitelist: path(ROOTS_DASHBOARD, "/whitelist-email"),
  TestWithRole: path(ROOTS_DASHBOARD, "/test-roles"),
  SystemWithdrawHistoryLog: path(ROOTS_DASHBOARD, "/system-withdraw-history"),
  AdminManagement: path(ROOTS_DASHBOARD, "/admin-management"),
  SystemBalances: path(ROOTS_DASHBOARD, "/system-balances"),
  Setting: path(ROOTS_DASHBOARD, "/settings/service-fee"),
  UnmatchedPayment: path(ROOTS_DASHBOARD, "/unmatched-payment"),
  AnhVinh: path(ROOTS_DASHBOARD, "/anh-vinh"),
  WithdrawalHistory: path(ROOTS_DASHBOARD, "/widthdrawal-history"),
  Charges: path(ROOTS_DASHBOARD, "/charges"),
  Payments: path(ROOTS_DASHBOARD, "/payments"),
  CryptoCurrency: path(ROOTS_DASHBOARD, "/settings/crypto-currencies"),
  RegisterEmail: path(ROOTS_DASHBOARD, "/register-email"),
  Merchants: path(ROOTS_DASHBOARD, "/merchants"),
  Users: path(ROOTS_DASHBOARD, "/users"),
  Chains: path(ROOTS_DASHBOARD, "/settings/chains"),
  NewPage: path(ROOTS_DASHBOARD, "/new-page"),
  network: path(ROOTS_DASHBOARD, "/network-new"),
};

export const PATH_COMMERCE = {
  invoices: path(ROOTS_COMMERCE, "/invoices"),
};
